import React, { useState, useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import AlgoStats from './AlgoStats';
import AlgoPerformanceComparison from './AlgoPerformanceComparison';
import AlgoFinder from './AlgoFinder';
import AlgoTimePeriods from './AlgoTimePeriods';
import { useParams } from 'react-router-dom';


function AlgoPerformance(props) {

    let { activeTab, startDate, endDate } = useParams();

    const [value, setValue] = useState(activeTab ? activeTab : 'summary');

    useEffect(() => {
        (async function () {
        })();
    }, []);


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
            <Box sx={{ bgcolor: '#F0F0F0', border: 1, borderBottom: 0, borderColor: 'black', borderRadius: 0 }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    textColor="secondary"
                    indicatorColor="secondary"
                >
                    <Tab value="summary" label="Summary" />
                    <Tab value="finder" label="Drill Down" />
                    <Tab value="timeperiods" label="Monthly" />
                    <Tab value="comparison" label="Comparison" />
                </Tabs>
            </Box>

            {value === "summary" ?
                <>
                    <AlgoStats role={props.role} userId={props.userId} mobileView={props.mobileView} planId={props.planId} onAlgoSelected={props.onAlgoSelected} />
                </>
                : null}
            {value === "finder" ?
                <>
                    <AlgoFinder role={props.role} user={props.user} mobileView={props.mobileView} planId={props.planId} startDate={startDate} endDate={endDate} />
                </>
                : null}
            {value === "timeperiods" ?
                <>
                    <AlgoTimePeriods role={props.role} user={props.user} mobileView={props.mobileView} planId={props.planId} />
                </>
                : null}
            {value === "comparison" ?
                <>
                    <AlgoPerformanceComparison mobileView={props.mobileView} planId={props.planId} onAlgoSelected={props.onAlgoSelected} />
                </>
                : null}

        </>
    );
}

export default AlgoPerformance;